import { render, staticRenderFns } from "./integralAddressAdd.vue?vue&type=template&id=5e8b5cca&scoped=true"
import script from "./integralAddressAdd.vue?vue&type=script&lang=js"
export * from "./integralAddressAdd.vue?vue&type=script&lang=js"
import style0 from "./integralAddressAdd.vue?vue&type=style&index=0&id=5e8b5cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8b5cca",
  null
  
)

export default component.exports